var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4C17.3125 4 18 4.6875 18 5.5V14.5C18 15.3438 17.3125 16 16.5 16H3.5C2.65625 16 2 15.3438 2 14.5V5.5C2 4.6875 2.65625 4 3.5 4H16.5ZM3.5 5C3.21875 5 3 5.25 3 5.5V6.8125C3.65625 7.375 4.65625 8.1875 7.6875 10.5938C8.21875 11.0312 9.25 12.0312 10 12C10.7188 12.0312 11.75 11.0312 12.2812 10.5938C15.3125 8.1875 16.3125 7.375 17 6.8125V5.5C17 5.25 16.75 5 16.5 5H3.5ZM16.5 15C16.75 15 17 14.7812 17 14.5V8.09375C16.2812 8.6875 15.1562 9.59375 12.9062 11.375C12.25 11.9062 11.125 13.0312 10 13C8.84375 13.0312 7.71875 11.9062 7.0625 11.375C4.8125 9.59375 3.6875 8.6875 3 8.09375V14.5C3 14.7812 3.21875 15 3.5 15H16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b246661bda8ed79cc4843109b6e3c076.svg";
export { ForwardRef as ReactComponent };